
export default {
  computed: {
    isOpen: function () {
      return this.$store.state['pop-up-notification']?.isOpen;
    },
    title: function () {
      console.log('this.$store.state[\'pop-up-notification\']: ', this.$store.state['pop-up-notification']);
      return this.$store.state['pop-up-notification']?.settings?.title || '';
    },
    message: function () {
      return this.$store.state['pop-up-notification']?.settings?.message || '';
    },
  },
};
